/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetPositionSpecialistTeamDto
 */
export interface GetPositionSpecialistTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetPositionSpecialistTeamDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPositionSpecialistTeamDto
     */
    positionId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPositionSpecialistTeamDto
     */
    teamId: string;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetPositionSpecialistTeamDto
     */
    team?: GetTeamDto;
}

/**
 * Check if a given object implements the GetPositionSpecialistTeamDto interface.
 */
export function instanceOfGetPositionSpecialistTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "positionId" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function GetPositionSpecialistTeamDtoFromJSON(json: any): GetPositionSpecialistTeamDto {
    return GetPositionSpecialistTeamDtoFromJSONTyped(json, false);
}

export function GetPositionSpecialistTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPositionSpecialistTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'positionId': json['positionId'],
        'teamId': json['teamId'],
        'team': !exists(json, 'team') ? undefined : GetTeamDtoFromJSON(json['team']),
    };
}

export function GetPositionSpecialistTeamDtoToJSON(value?: GetPositionSpecialistTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'positionId': value.positionId,
        'teamId': value.teamId,
        'team': GetTeamDtoToJSON(value.team),
    };
}

